import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BillingPeriod, BillingPeriodConfig} from '../billing-filter/ec-billing-filter.component';

@Component({
    selector: 'app-filter-bar',
    templateUrl: './filter-bar.component.html',
    styleUrls: ['./filter-bar.component.scss']
})

export class FilterBarComponent implements OnInit {

    @Input() config: BillingPeriodConfig;
    @Input() billingPeriod: BillingPeriod;
    @Input() useFilter: boolean;
    @Input() showNullData: boolean;
    @Input() showGSEBtn: boolean;
    @Input() isGSEDisabled: boolean;
    @Input() templateIsDownloading: boolean;
    @Input() response: any;
    @Output() billingPeriodEventEmitter: EventEmitter<BillingPeriod> = new EventEmitter<BillingPeriod>();
    @Output() clickGseDataEventEmitter: EventEmitter<void> = new EventEmitter<void>();
    @Output() exportDataEventEmitter: EventEmitter<void> = new EventEmitter<void>();

    ngOnInit(): void {
    }

    onChangeBillingPeriod($event: BillingPeriod) {
        this.billingPeriodEventEmitter.next($event);
    }

    onClickEnterGseData() {
        this.clickGseDataEventEmitter.next();
    }

    exportEconomicsToExcel() {
        this.exportDataEventEmitter.next();
    }
}
